import {
    Avatar,
    Button,
    CircularProgress,
    Container,
    CssBaseline,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from "@mui/material";
import green from "@mui/material/colors/green";
import { withStyles } from "@mui/styles";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import axios from "axios";
import * as React from "react";
import cookie from "react-cookies";
import * as QRCode from "qrcode";
import { ErrorMessage } from "../../components/ErrorMessage";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { tr } from "date-fns/locale";
import { any } from "prop-types";
import ReCAPTCHA from "react-google-recaptcha"

interface AuthProps {
    isAuthorized(data: any): void;
    classes: any;
    modal?: boolean;
}

interface AuthState {
    loading: boolean;
    error: null | string;
    username: string;
    password: string;
    token: string;
    modalType: number; // 0 - show login, 1 - show 2fa generate, 2 -  show ui input code
    otpauth_url: string;
    qrcodeUrl: string;
    secret_key: string;
    captchaValue: string;
}

class AuthorizationWrapped extends React.Component<AuthProps, AuthState> {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: null,
            // Input values
            username: "",
            password: "",
            token: "",
            modalType: 0,
            otpauth_url: "",
            qrcodeUrl: "",
            secret_key: "",
            captchaValue: "",
        };
    }

    componentDidMount() {
        document.title = Helpers.documentTitle("Login");
    }

    updateLoginState(response: any) {
        if (response.data.sessionId.length === 0) {
            // send request to generate 2fa code
            if (!response.data.data.otp_verified || response.data.data.otp_verified === false)
                this.gen2faCode(response.data.data);
            else {
                this.setState({ modalType: 2 });
                this.setState({ username: response.data.data.username });
            }
            return;
        }
        const expireDate = new Date();

        expireDate.setHours(expireDate.getHours() + 4);

        // Set authorization cookies
        cookie.save("active-env", response.data?.defaultEnv || "stage");

        cookie.save("brl-session-token", response.data.sessionId, {
            expires: expireDate,
        });

        cookie.save("username", response.data.data.username, {expires: expireDate});
        cookie.save("permissions", response.data.data.permissions, {expires: expireDate});
        
        setTimeout(() => {
            this.props.isAuthorized(response.data.data);
        }, 500);
    }

    /*
     * 
     */
    gen2faCode = (data: any) => {
        if (data.otp_enabled && data.otp_verified === false) {
            // Let's try to login
            axios.post(`${Config.getInstance.apiUrl}/api/otp/generate`, {
                userId: data.userId,
                username: data.username,
                
            }).then((result) => {
                this.setState({ loading: false, password: "", username: "" }, async () => {
                    //this.updateLoginState(result);
                    this.setState({ modalType: 1 });
                    this.setState({ otpauth_url: result.data.data.otpauth_url });
                    this.setState({ username: result.data.data.username });
                    this.setState({ secret_key: result.data.data.secret_key });        
                    await this.genQRCodeUrl(result.data.data.otpauth_url);
                });
            }).catch(() => {
                this.setState({
                    loading: false,
                    password: "",
                    error: "Something went wrong!",
            });
       });

        }
        else {
            this.setState({
                loading: false,
                password: "",
                error: "Something went wrong!",
            });
        }
    }

    genQRCodeUrl = async (otpauth_url: string ) => {
        try {
        const qrcodeUrl = await QRCode.toDataURL(otpauth_url);
        this.setState({ qrcodeUrl});
        } catch (err) {
            console.log("QR code url error:", err);
        }
    }

    submitForm = event => {
        event.preventDefault();

        this.setState({ loading: true, error: null }, () => {
            // Let's try to login
            axios.post(`${Config.getInstance.apiUrl}/api/login`, {
                username: this.state.username,
                password: this.state.password,
                captchaValue: this.state.captchaValue,
            }).then((result) => {
                this.setState({ loading: false, password: "", username: "" }, () => {
                    this.updateLoginState(result);
                 });
           }).catch(() => {
                this.setState({
                    loading: false,
                    password: "",
                    error: "Something went wrong!",
                });
           });
        });
    }

    closeModal = () => {
        this.setState({ modalType: 0 });
    }

    submitVerifyCode = (event?: any) => {
        if (event) {
            event.preventDefault();
        }
        
        this.setState({ loading: true, error: null }, () => {
            // Let's try to login
            axios.post(`${Config.getInstance.apiUrl}/api/otp/verify`, {
                username: this.state.username,
                token: this.state.token,
            }).then((result) => {
                this.setState({ loading: false, password: "", username: "", token: "" }, () => {
                    this.updateLoginState(result);
                 });
           }).catch((err) => {
            console.log("submitVerifyCode ------------- error", err);
                            this.setState({
                    loading: false,
                    password: "",
                    error: "Something went wrong, maybe invalid code!",
                });
           });
        });
    }

    submitValidateCode = (event?: any) => {
        if (event) {
            event.preventDefault();
        }
        
        this.setState({ loading: true, error: null }, () => {
            console.log('alfjlasdjflasdjlfas saljsalafsjlfsadjlkfalssd');
            // Let's try to login
            axios.post(`${Config.getInstance.apiUrl}/api/otp/validate`, {
                username: this.state.username,
                token: this.state.token,
                captchaValue: this.state.captchaValue,
            }).then((result) => {
                console.log('submitValidateCode ==== ', result);
                this.setState({ loading: false, password: "", username: "" }, () => {
                    this.updateLoginState(result);
                 });
           }).catch((err) => {
            console.log("submitValidateCode ------------- error", err);
                            this.setState({
                    loading: false,
                    password: "",
                    error: "Something went wrong, maybe invalid code!",
                });
           });
        });
    }
    

    handleInputChange = event => {
        const target = event.target;
        this.setState({ [target.name as any]: target.value });
    }

    googleResponseSuccess = async (data: any) => {
        try {
            const response = await axios.post(`${Config.getInstance.apiUrl}/api/oauth/google`, data);
            this.updateLoginState(response);
        } catch (e) {
            PopupMessage.error(`Failed to login with Google: ${e.message}`);
        }
    }

    googleResponseFailure = (response) => {
        console.error("Google failure", response);
        PopupMessage.error("Failed to login with Google!");
    }

    onChangeCaptcha = (value) => {
        this.setState({ captchaValue: value });
    }

    render() {
        const { classes } = this.props;

        // Show 2fa generate
        if (this.state.modalType === 1) {
            return (
                <Dialog aria-labelledby="authorization-popup" open={true} className="white-background-dialog">
                    <DialogContent>
                        <GoogleOAuthProvider clientId="708208661424-uuae4lvct163g1ul4rk5g50elnkt9494.apps.googleusercontent.com">
                <form className={classes.form} noValidate onSubmit={this.submitVerifyCode}>
                {this.state.error !== null &&
                                    <ErrorMessage message={this.state.error}/>
                                }
                <div
      aria-hidden={true}
      className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal md:h-full bg-[#222] bg-opacity-50"
      // onClick={closeModal}
    >
      <div className="relative p-4 w-full max-w-xl h-full md:h-auto left-1/2 -translate-x-1/2">
        <div className="relative bg-white rounded-lg shadow">
          <h3 className={styles.heading3}>Two-Factor Authentication (2FA)</h3>
          {/* Modal body */}
          <div className="p-6 space-y-4">
            <h4 className={styles.heading4}>
              Configuring Google Authenticator or Authy
            </h4>
            <div className={styles.orderedList}>
              <li>
                Install Google Authenticator (IOS - Android) or Authy (IOS -
                Android).
              </li>
              <li>In the authenticator app, select "+" icon.</li>
              <li>
                Select "Scan a barcode (or QR code)" and use the phone's camera
                to scan this barcode.
              </li>
            </div>
            <div>
              <h4 className={styles.heading4}>Scan QR Code</h4>
              <div className="flex justify-center">
                <img
                  className="block w-64 h-64 object-contain"
                  src={this.state.qrcodeUrl}
                  alt="qrcode url"
                />
              </div>
            </div>
            <div>
              <h4 className={styles.heading4}>Verify Code</h4>
              <p className="text-sm">
                Please enter the authentication code to verify your account:
              </p>
            </div>
            <div>
              <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="token"
                                label="Authentication Code"
                                id="token"
                                autoComplete="current-token"
                                value={this.state.token}
                                onChange={this.handleInputChange}
                            />
              
              <div className={styles.buttonGroup}>
                <button
                  type="button"
                  onClick={this.closeModal.bind(this)}
                  className={styles.buttonGrey}
                  disabled={this.state.loading}
                >
                  Close
                </button>
                <button type="submit"
                 className={styles.buttonBlue} 
                 disabled={this.state.loading}>
                    
                  Verify & Activate
                </button>
                {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </form>
    </GoogleOAuthProvider>
                    </DialogContent>
                </Dialog>
            );
        } else if (this.state.modalType === 2) { // show ui input code
            return(
                <Dialog aria-labelledby="authorization-popup" open={true} className="white-background-dialog">
                    <DialogContent>
                    {this.state.error !== null &&
                                    <ErrorMessage message={this.state.error}/>
                                }
            <section className="bg-ct-blue-600 min-h-screen grid place-items-center">
                
            <div className="w-full">
              <h1 className="text-4xl lg:text-6xl text-center font-[600] text-ct-yellow-600 mb-4">
              Verify the Authentication Code
              </h1>
              <form
                onSubmit={this.submitValidateCode}
                className="max-w-md w-full mx-auto overflow-hidden shadow-lg bg-ct-dark-200 rounded-2xl p-8 space-y-5"
              >
                <p className="text-center text-sm">
                  Open the two-step verification app on your mobile device (or using web plugin) to get your
                  verification code.
                </p>
                <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="token"
                                label="Authentication Code"
                                id="token"
                                autoComplete="current-token"
                                value={this.state.token}
                                onChange={this.handleInputChange}
                            />
                
                <div className={classes.wrapper}>
                                <Button disableElevation
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        disabled={this.state.loading}
                                >
                                    Authenticate
                                </Button>
                                {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                            {/*
                            <div style={{ textAlign: "center" }}>
                                    OR
                                <div className="googleLogin--wrapper">
                                <Button disableElevation
                                        fullWidth
                                        variant="contained"
                                        className={classes.submit}
                                        disabled={this.state.loading}
                                        onClick={this.closeModal.bind(this)}
                                >
                                    Back to Login
                                </Button>
                                </div>
                            </div>
                            */}
              </form>
            </div>
          </section>
          </DialogContent>
          </Dialog>
          );
        } 

        if (this.props.modal && false) {
            return (
                <Dialog aria-labelledby="authorization-popup" open={true} className="white-background-dialog">
                    <DialogTitle id="authorization-popup">Session timeout</DialogTitle>
                    <DialogContent>
                        <GoogleOAuthProvider clientId="708208661424-uuae4lvct163g1ul4rk5g50elnkt9494.apps.googleusercontent.com">
                            <form className={classes.form} noValidate onSubmit={this.submitForm}>
                                {this.state.error !== null &&
                                    <ErrorMessage message={this.state.error}/>
                                }

                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required={true}
                                    fullWidth={true}
                                    id="username"
                                    label="Username"
                                    name="username"
                                    autoFocus
                                    value={this.state.username}
                                    onChange={this.handleInputChange}
                                />

                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    value={this.state.password}
                                    onChange={this.handleInputChange}
                                />

                                <div style={{
                                    position: "relative",
                                }}>
                                    <Button disableElevation
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            className={classes.submit}
                                            disabled={this.state.loading}
                                    >
                                        Continue
                                    </Button>
                                    {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </div>
                                {/*
                                <div style={{ textAlign: "center" }}>
                                    <p>
                                        OR
                                    </p>

                                    <div className="googleLogin--wrapper">
                                        <GoogleLogin
                                            onSuccess={this.googleResponseSuccess}
                                            onError={this.googleResponseFailure}
                                        />
                                    </div>
                                </div>
                                */}
                            </form>
                        </GoogleOAuthProvider>
                    </DialogContent>
                </Dialog>
            );
        }

        /* show login UI */
        return (
            <GoogleOAuthProvider clientId="708208661424-uuae4lvct163g1ul4rk5g50elnkt9494.apps.googleusercontent.com">
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <div className={classes.paper}>
                        <Avatar
                            className={classes.avatar}
                            src={require(`../../../assets/images/icons/${Config.getInstance.getSettingByKey("SITE_LOGO")}`).default}
                            style={{ width: 70, height: 70 }}
                        />

                        <Typography component="h1" variant="h5">
                            {Config.getInstance.getSettingByKey("SITE_NAME")}
                        </Typography>
                        <form className={classes.form} noValidate onSubmit={this.submitForm}>

                            {this.state.error !== null &&
                                <ErrorMessage message={this.state.error}/>
                            }

                            <TextField
                                variant="outlined"
                                margin="normal"
                                required={true}
                                fullWidth={true}
                                id="username"
                                label="Username"
                                name="username"
                                autoFocus
                                value={this.state.username}
                                onChange={this.handleInputChange}
                            />

                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={this.state.password}
                                onChange={this.handleInputChange}
                            />
                            
                            <div className={classes.wrapper}>
                                <ReCAPTCHA  sitekey="6LfoZ1UnAAAAAKCUMbWkV7wFL9Lv6vln3rARGAi-" onChange={this.onChangeCaptcha} />
                            </div>                           

                            <div className={classes.wrapper}>
                                <Button disableElevation
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        disabled={this.state.loading}
                                >
                                    Sign In
                                </Button>
                                {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                            {/*
                            <div style={{ textAlign: "center" }}>
                                <p>
                                    OR
                                </p>
                                <div className="googleLogin--wrapper">
                                    <GoogleLogin
                                        onSuccess={this.googleResponseSuccess}
                                        onError={this.googleResponseFailure}
                                    />     
                                </div>
                            </div>
                            */}
                        </form>
                    </div>
                </Container>
            </GoogleOAuthProvider>
        );
    }
}

const styles: any = theme => ({
    "paper": {
        marginTop: 20,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    "avatar": {
        margin: 20,
    },
    "form": {
        width: "100%", // Fix IE 11 issue.
        marginTop: 20,
    },
    "submit": {
        margin: "15px 0px",
    },
    "buttonProgress": {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
});

export const Authorization = withStyles(styles)(AuthorizationWrapped);
